import React from 'react'
import '../setting/user/user-setting.css';
import './reimbursemnt-method.css';
import { Typography } from 'antd';
import HeadphoneIcon from '../../../assets/icons/headphones.svg'
import BackButton from '../../../components/button/back-button';

const SupportPage = () => {
    const { Title, Text } = Typography;

    return (
        <div className='user-setting-layout'>
            <div className='w-100'>
                <BackButton />
            </div>
            <div className='w-100 d-flex flex-column align-items-center justify-content-center mt-4 gap-3'>
                <div className='icon-bg-round' style={{ width: '50px', height: '50px' }}>
                    <img alt="head-phone-icon" src={HeadphoneIcon} />
                </div>
                <Title level={4} style={{ fontSize: '24px' }}>Contact Us</Title>
                <div className='d-flex flex-column gap-3'>
                    <Text style={{ fontSize: '16px' }} strong>Savings Card Reimbursement Claims Support</Text>
                    <Text style={{ fontSize: '16px' }}><span style={{ fontWeight: 'bold' }}>Phone Number:</span> (844) 320-9707</Text>
                    <Text style={{ fontSize: '16px' }}><span style={{ fontWeight: 'bold' }}>Address:</span><br />Paysign<br />P.O. Box 530492<br />Henderson. NV 89053</Text>
                    <Text style={{ fontSize: '16px' }}><span style={{ fontWeight: 'bold' }}>Hours of operation:</span><br />24 hours a day / 365 days a year</Text>
                </div>
            </div>
        </div>
    )
}

export default SupportPage